import { array, dateTime, defineAction, number, object, string } from '~/prix'
import monitorUsageAnalyticsSummaryAction from './monitorUsageAnalyticsSummary.action.json'

const timeBucketItem = object({
  period: string(),
  count: number(),
})

const summaryOutput = object({
  items: array(
    object({
      key: string(),
      label: string(),
      source: string(),
      value: number(),
    }),
  ),
})

const mostAccessedFeatureOutput = object({
  key: string(),
  label: string(),
  accesses: number(),
  averageResponseTimeMs: number().isOptional(),
  firstSeenAt: dateTime().isOptional(),
  lastSeenAt: dateTime().isOptional(),
})

const generatedReportsOutput = object({
  total: number(),
  reportOutputRows: number(),
  actionRunAdjustedTotal: number(),
  generationActionRuns: number(),
  byReport: array(
    object({
      reportKey: string(),
      reportTitle: string(),
      actionKey: string().isOptional(),
      count: number(),
      reportOutputRows: number(),
      actionRuns: number(),
      estimatedGeneratedCount: number(),
      lastGeneratedAt: dateTime().isOptional(),
    }),
  ),
})

const generatedExportsOutput = object({
  total: number(),
  actionRuns: number(),
  items: array(
    object({
      actionKey: string(),
      label: string(),
      count: number(),
      actionRuns: number(),
      firstSeenAt: dateTime().isOptional(),
      lastSeenAt: dateTime().isOptional(),
    }),
  ),
})

const usageSummaryOutput = object({
  label: string(),
  summary: summaryOutput,
  dailyAccesses: array(timeBucketItem),
  monthlyAccesses: array(timeBucketItem),
  yearlyAccesses: array(timeBucketItem),
  distinctUsersByDay: array(timeBucketItem),
  distinctUsersByMonth: array(timeBucketItem),
  distinctUsersByYear: array(timeBucketItem),
  mostAccessedFeatures: array(mostAccessedFeatureOutput),
  generatedReports: generatedReportsOutput,
  generatedExports: generatedExportsOutput,
})

const monitorUsageAnalyticsSummaryDefinition = defineAction({
  ...monitorUsageAnalyticsSummaryAction,
  input: object({
    startDate: dateTime().isOptional(),
    endDate: dateTime().isOptional(),
    limit: number().isOptional(),
  }),
  output: object({
    period: object({
      startDate: dateTime(),
      endDate: dateTime(),
    }),
    monitor: usageSummaryOutput,
    appSebrae: usageSummaryOutput,
  }),
})

export default monitorUsageAnalyticsSummaryDefinition
